/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  WordTimestamp,
  WordTimestamp$inboundSchema,
  WordTimestamp$Outbound,
  WordTimestamp$outboundSchema,
} from "./wordtimestamp.js";

export type AudioModalityData = {
  type: "audio";
  wordTimestamps?: Array<WordTimestamp> | undefined;
};

/** @internal */
export const AudioModalityData$inboundSchema: z.ZodType<
  AudioModalityData,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: z.literal("audio"),
  word_timestamps: z.array(WordTimestamp$inboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    "word_timestamps": "wordTimestamps",
  });
});
/** @internal */
export type AudioModalityData$Outbound = {
  type: "audio";
  word_timestamps?: Array<WordTimestamp$Outbound> | undefined;
};

/** @internal */
export const AudioModalityData$outboundSchema: z.ZodType<
  AudioModalityData$Outbound,
  z.ZodTypeDef,
  AudioModalityData
> = z.object({
  type: z.literal("audio"),
  wordTimestamps: z.array(WordTimestamp$outboundSchema).optional(),
}).transform((v) => {
  return remap$(v, {
    wordTimestamps: "word_timestamps",
  });
});

export function audioModalityDataToJSON(
  audioModalityData: AudioModalityData,
): string {
  return JSON.stringify(
    AudioModalityData$outboundSchema.parse(audioModalityData),
  );
}
export function audioModalityDataFromJSON(
  jsonString: string,
): SafeParseResult<AudioModalityData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AudioModalityData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AudioModalityData' from JSON`,
  );
}
